<button (click)="onScrollTo()"
   [ngClass]="{active: visible}"
   [id]="this.selector"
   class="scroll-to-that-btn">
  <i class="fas fa-chevron-down"></i>
</button>
